
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62033_190)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M12.597 11.306V8a.75.75 0 011.5 0v3.306a.75.75 0 01-1.5 0z"}}),_c('path',{attrs:{"d":"M15 8.903l.077.003a.75.75 0 010 1.493l-.076.004h-3.306a.75.75 0 010-1.5H15zM3.233 5.246V1.94a.75.75 0 111.5 0v3.306a.75.75 0 01-1.5 0z"}}),_c('path',{attrs:{"d":"M5.636 2.843l.076.004a.75.75 0 010 1.492l-.076.004H2.33a.75.75 0 110-1.5h3.306zM9.292 14.06v-2.204a.75.75 0 011.5 0v2.203a.75.75 0 01-1.5 0z"}}),_c('path',{attrs:{"d":"M11.144 12.208l.077.004a.75.75 0 010 1.492l-.077.004H8.94a.75.75 0 010-1.5h2.204zM7.86 4.165a.75.75 0 011.003-.052l.057.052 2.203 2.203.052.057A.75.75 0 0110.12 7.48l-.057-.052-2.204-2.203-.051-.057a.75.75 0 01.051-1.003z"}}),_c('path',{attrs:{"d":"M3.203 13.227l9.312-9.311-1.143-1.143-9.311 9.311 1.142 1.143zm10.513-10.23a1.301 1.301 0 010 1.839l-9.593 9.592a1.301 1.301 0 01-1.84 0L.86 13.005a1.3 1.3 0 010-1.84l9.593-9.593a1.3 1.3 0 011.84 0l1.424 1.425z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62033_190"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    